var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"},on:{"enter":_vm.beginCycleCountdown}},[_c('div',{staticClass:"countdown-overlay",class:{ fading: _vm.lastWord }},[_c('BouncingText',{staticClass:"cycle-countdown",attrs:{"text":_vm.cycleText}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-279ba28c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/CycleCountdown.vue
// module id = null
// module chunks = 